/**
 * WOO COLOR PROFILE — 判定エンジン(DOMに触れない純粋関数のみ)
 *
 * パーソナルカラー診断。UNITED ARROWSのコラム型の分岐チャートを参考にした短い診断。
 * RURU決定(2026-09-10): 旧Shopify Forms版(/pages/color3 等)とは並存 / 3〜4問のチャート /
 * パーソナルカラーアナリスト監修前で公開し監修は後追い / 性別で商品を出し分ける。
 * 仕様正本: Vault 01_WooStore/Personal_Styling_CRM/26_WOO_COLOR_PROFILE_SPEC.md
 *
 * 流れ: 性別(スコア外) → ベース判定2問 → (2問が食い違ったときだけ)決め手の1問 → シーズン判定1問
 *  - ベース(イエロー/ブルー)は2〜3票の多数決。票が割れたら3票目を聞くので同票では終わらない
 *  - 2問が一致すれば certainty = 'clear'、決め手の1問で決まったら certainty = 'lean'
 *  - シーズンはベースごとに別の設問で決める(イエロー → 春/秋、ブルー → 冬/夏)
 *
 * 設問文言の正本はこのファイル(WSPのconfigと同じ位置づけ)。
 * 結果ページの文言の正本は sections/woo-color-profile-result.liquid。JSに持たせない。
 *
 * ブラウザでは window.WCP_ENGINE、Node(テスト)では module.exports。
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.WCP_ENGINE = api;
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // 1.1.0: u1を「血管の色」→「唇の色(写真)」へ差し替え、s_yellowに瞳の写真を追加(2026-09-10)
  var CONFIG_VERSION = '1.1.0-draft';
  var ALGORITHM_VERSION = 'wcp-chart-1';

  var QUESTIONS = {
    q_gender: {
      id: 'q_gender',
      title: 'ご覧になりたいアイテムは？',
      hint: '結果ページでおすすめするアイテムの切り替えに使います。診断結果には影響しません。',
      options: [
        { id: 'gender_women', label: 'レディース', value: 'WOMEN' },
        { id: 'gender_men', label: 'メンズ', value: 'MAN' }
      ]
    },
    // 2026-09-10 v1.1: 自己判定しにくい「手首の血管の色」を、写真で見比べられる「唇の色」に差し替えた
    // (RURU指示。画像はUNITED ARROWSのコラム素材で、RURU申告により利用許諾あり)。
    // image は画像キー。URLはLiquidが window.WCP_IMAGE_URLS に渡す(エンジンはDOM/URLを持たない)
    u1: {
      id: 'u1',
      title: '唇の色は、どちらに近い？',
      hint: 'リップを塗っていない状態で、写真と見比べて近い方を選んでください。',
      options: [
        { id: 'u1_blue', label: '赤紫系(ピンク・ローズ寄り)', base: 'blue', image: 'lips_blue' },
        { id: 'u1_yellow', label: '赤茶系(コーラル・オレンジ寄り)', base: 'yellow', image: 'lips_yellow' }
      ]
    },
    u2: {
      id: 'u2',
      title: '顔の近くにつけたとき、肌になじんで見えるアクセサリーは？',
      hint: '手持ちのアクセサリーや、試着したときの印象で選んでください。',
      options: [
        { id: 'u2_blue', label: 'シルバー', base: 'blue' },
        { id: 'u2_yellow', label: 'ゴールド', base: 'yellow' }
      ]
    },
    u3: {
      id: 'u3',
      title: '白いトップスを着たとき、顔色が明るく見えるのは？',
      hint: 'ここまでの回答が分かれたので、もう1問だけ確認させてください。',
      options: [
        { id: 'u3_blue', label: '真っ白(純白)', base: 'blue' },
        { id: 'u3_yellow', label: 'アイボリー・生成り', base: 'yellow' }
      ]
    },
    s_yellow: {
      id: 's_yellow',
      title: 'あなたの瞳と印象に近いのは？',
      hint: '鏡を少し離して、明るい場所で瞳を見てください。',
      image: 'eye_clear',
      imageCaption: '写真のように、瞳が明るいブラウンで虹彩(黒目のまわりの模様)がはっきり見えるなら、1つ目の選択肢が近いタイプです。',
      options: [
        { id: 's_spring', label: '瞳は明るいブラウンで、虹彩がはっきり見える。明るく軽やかな印象', season: 'spring' },
        { id: 's_autumn', label: '瞳は深いブラウンで、黒目の輪郭がやわらか。落ち着いた大人っぽい印象', season: 'autumn' }
      ]
    },
    s_blue: {
      id: 's_blue',
      title: 'あなたの印象に近いのは？',
      hint: '周りから言われることが多い方を選んでください。',
      options: [
        { id: 's_winter', label: 'くっきり華やか。黒目と白目の境目がはっきりしている', season: 'winter' },
        { id: 's_summer', label: 'やさしく上品。瞳の印象がやわらかく、境目がなだらか', season: 'summer' }
      ]
    }
  };

  var SEASONS = ['spring', 'summer', 'autumn', 'winter'];
  var SEASON_BASE = { spring: 'yellow', autumn: 'yellow', summer: 'blue', winter: 'blue' };
  var SEASON_NAMES = { spring: 'イエベ春', summer: 'ブルベ夏', autumn: 'イエベ秋', winter: 'ブルベ冬' };
  var BRANCH_BY_BASE = { yellow: 's_yellow', blue: 's_blue' };

  /**
   * 商品のColorオプション値 → シーズンの対応表。
   * 値はWooStoreの実データ(2026-09-10、/collections/womens のフィルタ一覧と最新250商品)に
   * 実在する表記から選んだ。1つの値は1シーズンにだけ属する(テストで重複を検出する)。
   * 比較は normalizeColor() を通した大文字・前後空白除去の完全一致。
   * この対応表自体がパーソナルカラーアナリストの監修対象(26_WOO_COLOR_PROFILE_SPEC.md)。
   */
  var SEASON_COLORS = {
    spring: [
      'IVORY', 'OFF WHITE', 'CREAM', 'CREAM BEIGE', 'LIGHT BEIGE', 'BUTTER', 'BUTTER YELLOW',
      'LIGHT YELLOW', 'YELLOW', 'MELON', 'MINT', 'CORAL', 'PEACH', 'SORBET', 'LIME',
      'アイボリー', 'エクリュ'
    ],
    summer: [
      'LIGHT GRAY', 'LIGHT GREY', 'GRAY', 'GREY', 'MELANGE', 'MELANGE GRAY', 'SILVER GRAY',
      'BLUE GRAY', 'MINT GRAY', 'SKY BLUE', 'SKYBLUE', 'SORA', 'LIGHT SORA', 'LIGHT BLUE',
      'L-BLUE', 'MEDIUM BLUE', 'DENIM', 'DENIM BLUE', 'PINK', 'LAVENDER', 'VIOLET',
      'WHITE MELANGE', 'ピンク'
    ],
    autumn: [
      'BEIGE', 'OAT', 'OAT BEIGE', 'OATMEAL', 'MELANGE BEIGE', 'CAMEL', 'KHAKI', 'KHAKI BEIGE',
      'KHAKI BROWN', 'ASH KHAKI', 'LIGHT KHAKI', 'OLIVE', 'GREEN', 'MUSTARD', 'ORANGE', 'BRICK',
      'TAUPE', 'BROWN', 'BEIGE BROWN', 'DARK BROWN', 'DEEP BROWN', 'CHOCO BROWN', 'MOCHA',
      'MOCHA BROWN', 'COCOA', 'ブラウン', 'グリーン'
    ],
    winter: [
      'BLACK', 'WHITE', 'CHARCOAL', 'CHARCOAL GREY', 'MELANGE CHARCOAL', 'DARK GRAY', 'DARK GREY',
      'NAVY', 'DARK BLUE', 'DEEP BLUE', 'BLUE', 'INDIGO', 'DARK DENIM', 'BURGUNDY', 'WINE', 'RED',
      'PURPLE', 'SILVER', 'ブラック', 'チャコール', 'ブルー'
    ]
  };

  var COLOR_TO_SEASON = (function () {
    var map = {};
    SEASONS.forEach(function (season) {
      SEASON_COLORS[season].forEach(function (value) {
        map[normalizeColor(value)] = season;
      });
    });
    return map;
  })();

  /**
   * 表記ゆれを吸収する。大文字化、「BLACK : 無地」「GRAY(杢)」のような補足の除去、空白の正規化。
   */
  function normalizeColor(value) {
    if (value === null || value === undefined) return '';
    return String(value)
      .toUpperCase()
      .replace(/\s*[:：(（].*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function seasonForColor(value) {
    var key = normalizeColor(value);
    return key && Object.prototype.hasOwnProperty.call(COLOR_TO_SEASON, key) ? COLOR_TO_SEASON[key] : null;
  }

  function isSeason(value) {
    return SEASONS.indexOf(value) !== -1;
  }

  /** answers[qid] が有効な選択肢1つなら、その選択肢オブジェクトを返す */
  function findOption(qid, answers) {
    var q = QUESTIONS[qid];
    if (!q || !answers) return null;
    var picked = answers[qid];
    if (!Array.isArray(picked) || picked.length !== 1) return null;
    for (var i = 0; i < q.options.length; i++) {
      if (q.options[i].id === picked[0]) return q.options[i];
    }
    return null;
  }

  /**
   * 回答をチャートどおりにたどる。
   * path = 聞いた順の設問ID(未回答の設問に当たったらその設問まで含めて止まる)
   * next = 次に聞く設問ID(全部済んでいれば null)
   * 経路外の回答(戻って答えを変えたあとに残った別分岐の回答など)は読まない。
   */
  function walk(answers) {
    var path = [];
    function ask(qid) {
      path.push(qid);
      return findOption(qid, answers);
    }

    var gender = ask('q_gender');
    if (!gender) return { path: path, next: 'q_gender' };
    var u1 = ask('u1');
    if (!u1) return { path: path, next: 'u1' };
    var u2 = ask('u2');
    if (!u2) return { path: path, next: 'u2' };

    var votes = { yellow: 0, blue: 0 };
    votes[u1.base]++;
    votes[u2.base]++;
    var certainty = 'clear';
    if (u1.base !== u2.base) {
      var u3 = ask('u3');
      if (!u3) return { path: path, next: 'u3' };
      votes[u3.base]++;
      certainty = 'lean';
    }

    var base = votes.yellow > votes.blue ? 'yellow' : 'blue';
    var branch = ask(BRANCH_BY_BASE[base]);
    if (!branch) return { path: path, next: BRANCH_BY_BASE[base] };

    return {
      path: path,
      next: null,
      gender: gender.value,
      base: base,
      votes: votes,
      certainty: certainty,
      season: branch.season
    };
  }

  function nextQuestionId(answers) {
    return walk(answers).next;
  }

  function pathFor(answers) {
    return walk(answers).path;
  }

  /**
   * 進捗表示用の総問数の見込み。基本は4問(性別+ベース2+シーズン1)。
   * ベースの2問が食い違った時点で5問に増える。
   */
  function estimatedTotal(answers) {
    var w = walk(answers);
    var remainingAfter = { q_gender: 3, u1: 2, u2: 1, u3: 1, s_yellow: 0, s_blue: 0 };
    if (w.next === null) return w.path.length;
    return w.path.length + remainingAfter[w.next];
  }

  /**
   * 回答から結果を確定する。未知の設問ID・存在しない選択肢は全体を拒否する(WSPと同じ方針)。
   */
  function computeResult(answers) {
    if (!answers || typeof answers !== 'object' || Array.isArray(answers)) {
      return { ok: false, reason: 'no_answers' };
    }
    var keys = Object.keys(answers);
    for (var i = 0; i < keys.length; i++) {
      if (!QUESTIONS[keys[i]]) return { ok: false, reason: 'unknown_question:' + keys[i] };
      if (!findOption(keys[i], answers)) return { ok: false, reason: 'invalid_answer:' + keys[i] };
    }
    var w = walk(answers);
    if (w.next) return { ok: false, reason: 'incomplete:' + w.next };
    return {
      ok: true,
      season: w.season,
      base: w.base,
      certainty: w.certainty,
      votes: w.votes,
      profile: { gender: w.gender },
      configVersion: CONFIG_VERSION,
      algorithmVersion: ALGORITHM_VERSION
    };
  }

  /** products.json の商品から Color オプションの位置(1〜3)を探す */
  function colorOptionPosition(product) {
    var options = product && product.options;
    if (!Array.isArray(options)) return 0;
    for (var i = 0; i < options.length; i++) {
      var name = String((options[i] && options[i].name) || '').trim();
      if (/^(colou?r|カラー|色)$/i.test(name)) {
        return options[i].position || i + 1;
      }
    }
    return 0;
  }

  /**
   * /collections/{handle}/products.json の商品配列から、シーズンに合う色の在庫ありバリアントを持つ商品を選ぶ。
   * 1商品につき最初に合致したバリアント1つ。
   *
   * 同じ色ばかりで埋まらないよう、1巡目は1色あたり ceil(上限/4) 件まで(8件なら2件)に抑えて
   * コレクションの並び順どおりに採り、足りない分を2巡目で並び順どおりに埋める。
   * 実測(2026-09-10): womensはIVORYが379件あり、上限を設けないと春の8件が全てIVORY/CREAMになった。
   * @returns {Array<{product: object, variant: object, color: string}>}
   */
  function pickProductsForSeason(products, season, limit) {
    var out = [];
    if (!Array.isArray(products) || !isSeason(season)) return out;
    var max = typeof limit === 'number' && limit > 0 ? limit : 8;
    var perColor = Math.max(1, Math.ceil(max / 4));

    var candidates = [];
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!p || !Array.isArray(p.variants) || !p.handle) continue;
      var pos = colorOptionPosition(p);
      if (!pos) continue;
      for (var j = 0; j < p.variants.length; j++) {
        var v = p.variants[j];
        if (!v || v.available !== true) continue;
        var value = v['option' + pos];
        if (seasonForColor(value) === season) {
          candidates.push({ product: p, variant: v, color: normalizeColor(value) });
          break;
        }
      }
    }

    var counts = {};
    var used = [];
    for (var a = 0; a < candidates.length && out.length < max; a++) {
      var c = candidates[a];
      var key = colorFamily(c.color);
      if ((counts[key] || 0) < perColor) {
        counts[key] = (counts[key] || 0) + 1;
        used[a] = true;
        out.push(c);
      }
    }
    for (var b = 0; b < candidates.length && out.length < max; b++) {
      if (!used[b]) out.push(candidates[b]);
    }
    return out;
  }

  // 同じ色の表記ゆれ。色ごとの上限を数えるときだけ同一視する(対応表・フィルタ値は実表記のまま)
  var COLOR_FAMILY = {
    'GREY': 'GRAY', 'LIGHT GREY': 'LIGHT GRAY', 'DARK GREY': 'DARK GRAY',
    'SKYBLUE': 'SKY BLUE', 'L-BLUE': 'LIGHT BLUE', 'CHARCOAL GREY': 'CHARCOAL'
  };
  function colorFamily(color) {
    return Object.prototype.hasOwnProperty.call(COLOR_FAMILY, color) ? COLOR_FAMILY[color] : color;
  }

  /**
   * 色ごとの上限つき(1巡目)だけで何件埋まるか。結果ページの商品取得で「次のページも読むか」の判断に使う。
   * 候補の総数で打ち切ると、先頭に同じ色が多いときに色の偏りが残る(2026-09-10 Fable第2回レビュー MEDIUM:
   * 先頭50件の春候補26件はIVORY/CREAMだけで、200件まで読めばMINT・BUTTER・OFF WHITEが入る)。
   */
  function diverseCount(products, season, limit) {
    var max = typeof limit === 'number' && limit > 0 ? limit : 8;
    var perColor = Math.max(1, Math.ceil(max / 4));
    var all = pickProductsForSeason(products, season, Number.MAX_SAFE_INTEGER || 1e9);
    var counts = {};
    var n = 0;
    all.forEach(function (c) {
      var key = colorFamily(c.color);
      counts[key] = (counts[key] || 0) + 1;
      if (counts[key] <= perColor) n++;
    });
    return Math.min(n, max);
  }

  /** ストアフロントのカラーフィルタ(filter.v.option.color)に渡す値 */
  function filterValues(season) {
    return isSeason(season) ? SEASON_COLORS[season].slice() : [];
  }

  return {
    CONFIG_VERSION: CONFIG_VERSION,
    ALGORITHM_VERSION: ALGORITHM_VERSION,
    QUESTIONS: QUESTIONS,
    SEASONS: SEASONS,
    SEASON_BASE: SEASON_BASE,
    SEASON_NAMES: SEASON_NAMES,
    SEASON_COLORS: SEASON_COLORS,
    normalizeColor: normalizeColor,
    seasonForColor: seasonForColor,
    isSeason: isSeason,
    walk: walk,
    nextQuestionId: nextQuestionId,
    pathFor: pathFor,
    estimatedTotal: estimatedTotal,
    computeResult: computeResult,
    colorOptionPosition: colorOptionPosition,
    pickProductsForSeason: pickProductsForSeason,
    diverseCount: diverseCount,
    filterValues: filterValues
  };
});
